<fin-booking-widget-selector
  class="flex flex-1"
  [label]="'travelType.label' | finLocalization"
  [disabled]="disabled"
  (click)="openModal()"
  data-test-trip-type-selector
>
  <span class="flex--self-center" data-test-selected-trip-type>{{
    'travelType.' + TripTypeMapping[currentTripType$ | async] | finLocalization
  }}</span>
  <ng-template #contentTooltip>
    <p class="regular-type">
      {{ 'multiCity.description' | finLocalization }}
    </p>
    <a
      class="block medium-type font-body-1 mr-xsmall-t underline link-hover nordic-blue-900-text"
      [finLink]="'multiCity.url.url' | finLocalization"
      [external]="true"
      [openInNewTab]="true"
      [attr.rel]="'noreferrer'"
      [attr.aria-describedby]="'faq-link'"
      [attr.aria-label]="'faq'"
    >
      {{ 'multiCity.linkText' | finLocalization }}
      <fcom-icon name="external-tab" class="is-xsmall"></fcom-icon>
    </a>
  </ng-template>

  <button
    *ngIf="(currentTripType$ | async) === TripType.MULTICITY"
    type="button"
    fcomTooltip
    [options]="{ closeOnScroll: true }"
    [content]="contentTooltip"
    [ariaCloseText]="'actions.close' | finLocalization"
    [attr.aria-label]="'actions.info' | finLocalization"
    class="icon nordic-blue-900-text ms-xxsmall-l"
    data-test-trip-type-multicity-tooltip
  >
    <fcom-icon name="help-block" class="is-small"></fcom-icon>
  </button>
</fin-booking-widget-selector>

<fcom-modal
  [(open)]="modalOpen"
  [title]="'travelType.label' | finLocalization"
  [fitToContent]="true"
  [focusTarget]="selectedElement"
  data-test-trip-type-modal
>
  <div class="pr-large-x">
    <ul id="to-trip-type" role="radiogroup" class="flex flex--column ps-xxsmall-y">
      <li
        *ngFor="let tripType of availableTripTypes$ | async; let last = last; let i = index"
        [attr.id]="'to-trip-type-' + TripTypeMapping[tripType]"
        class="flex flex--middle flex--space-between focus-inset link-hover trip-type"
        [class.border-bottom]="!last"
        (click)="onTripTypeSelect(tripType, $event)"
      >
        <input
          #tripTypeRadioBtn
          type="radio"
          class="is-vishidden"
          (keyup)="handleKeyPress(tripType, $event)"
          [attr.id]="'tripType-' + tripType"
          name="tripType"
          [value]="tripType"
          [checked]="(currentTripType$ | async) === tripType"
          [tabindex]="(currentTripType$ | async) === tripType ? 0 : -1"
        />
        <label
          [for]="'tripType-' + tripType"
          class="fill font-body-1 ps-medium-y link-hover nordic-blue-900-text"
          data-test-trip-type-label
        >
          {{ 'travelType.' + TripTypeMapping[tripType] | finLocalization }}
        </label>

        <fcom-icon
          *ngIf="(currentTripType$ | async) === tripType"
          name="checkmark"
          class="is-small nordic-blue-900-text"
        ></fcom-icon>
      </li>
    </ul>
  </div>
</fcom-modal>
